// src/pages/AuthCallback.js
import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { authAPI } from "../services/api";
import {
  Container,
  Box,
  Paper,
  Typography,
  CircularProgress,
  Alert,
  Button,
} from "@mui/material";

const AuthCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState("");

  useEffect(() => {
    const accessToken = searchParams.get("accessToken");
    const refreshToken = searchParams.get("refreshToken");

    if (accessToken && refreshToken) {
      // Revoke any existing session before setting new tokens
      const oldRefreshToken = localStorage.getItem("refreshToken");
      if (oldRefreshToken && oldRefreshToken !== refreshToken) {
        // Best-effort: revoke old session server-side, don't block on failure
        authAPI.logout(oldRefreshToken).catch(() => {});
      }

      // Store new tokens
      localStorage.setItem("accessToken", accessToken);
      localStorage.setItem("refreshToken", refreshToken);

      // Clear the URL params for security (don't leave tokens in browser history)
      window.history.replaceState({}, document.title, "/auth-callback");

      // Redirect to dashboard
      setTimeout(() => {
      window.location.href = "/dashboard";
      }, 500);
    } else {
      setError("Invalid authentication link. Please try logging in manually.");
    }
  }, [searchParams, navigate]);

  if (error) {
    return (
      <Container maxWidth="sm">
        <Box
          sx={{
            marginTop: 8,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Paper elevation={3} sx={{ p: 4, width: "100%" }}>
            <Alert severity="error" sx={{ mb: 3 }}>
              {error}
            </Alert>
            <Button
              variant="contained"
              fullWidth
              onClick={() => navigate("/login")}
            >
              Go to Login
            </Button>
          </Paper>
        </Box>
      </Container>
    );
  }

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Paper elevation={3} sx={{ p: 4, width: "100%", textAlign: "center" }}>
          <CircularProgress sx={{ mb: 2 }} />
          <Typography>Signing you in...</Typography>
        </Paper>
      </Box>
    </Container>
  );
};

export default AuthCallback;
